import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_monocle: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-monocle" {...rest}>
      <title>praise-monocle</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#FB7F78"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
        opacity=".8"
      ></ellipse>
      <path
        fill="#646D7A"
        d="M22.6 94.7c3.8 0 6.4 8.9 14.3 8.9S49.3 84.9 66 84.9c6.5 0 10.6 5.1 10.6 12.1 0 8.2-9.4 18.9-26.7 18.9-30.1 0-30.7-21.2-27.3-21.2z"
      ></path>
      <circle fill="#FFF" cx="101.6" cy="51.2" r="17"></circle>
      <path
        fill="#343A41"
        d="M101.6 70.8c-10.9 0-19.7-8.8-19.7-19.7s8.8-19.7 19.7-19.7 19.7 8.8 19.7 19.7c-.1 10.9-8.9 19.7-19.7 19.7zm0-34c-7.9 0-14.3 6.4-14.3 14.3s6.4 14.3 14.3 14.3 14.3-6.4 14.3-14.3c0-7.8-6.4-14.3-14.3-14.3z"
      ></path>
      <path
        fill="#646D7A"
        d="M129 94.7c-3.8 0-6.4 8.9-14.3 8.9s-12.4-18.7-29.2-18.7C79 84.9 74.9 90 74.9 97c0 8.2 9.4 18.9 26.7 18.9 30.1 0 30.8-21.2 27.4-21.2z"
      ></path>
    </svg>
  );
};
